import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { UserResponse } from '@interfaces/user';
import { Select, Selector, Store } from '@ngxs/store';
import { CrossSellBannerComponent } from '@shared/components/cross-sell-banner/cross-sell-banner.component';
import { RemarksComponent } from '@shared/components/modal/remarks/remarks.component';
import { RemarksAddeddComponent } from '@shared/components/modal/remarks-addedd/remarks-addedd.component';
import { RequestCancellationComponent } from '@shared/components/modal/request-cancellation/request-cancellation.component';
import { SharedModule } from '@shared/shared.module';
import { CALCULATE_ENDT_PREMIUM, CALCULATE_PREMIUM, CANCEL_COVER_NOTE, CANCEL_QUOTATION, CANCEL_REPLACE, CONTINUE_ISSUANCE, COPY_CNGE_INFO, COPY_CNGE_TO_ENDORSEMENT_STATE, DOWNLOAD_PDF, GET_AGENT_DETAIL_ONLY, GET_AGENT_LIST_AGENT, GET_CROSS_SELL_LIST, GET_DOCUMENT_LOV, GET_NCD_ENQUIRY, GET_PRODUCT_LIST, GET_QUOTATION_DETAIL, GET_QUOTATION_DETAIL_ENDT, GET_REDIRECT_PAGE, GET_SWITCH_SITE, REQUEST_CANCELLATION, RESET_MOTOR_STATE, SAVE_REFERRAL_REMARKS, SEND_TO_JPJ, SET_ACTION, SET_CURRENT_STEP, SET_JPJ_STATUS_SENT, STORE_COMPLETE_DATA } from '@store/sat-motor/sat-motor.action';
import { EnquiryPopupComponent } from 'src/app/popup/enquiry-popup/enquiry-popup.component';
import { SatMotorState } from '@store/sat-motor/sat-motor.state';
import { Observable } from 'rxjs';
import { OkMessageComponent } from '@shared/components/modal/ok-message/ok-message.component';
import { StatusMessageComponent } from '@shared/components/status-message/status-message.component';
import { CompleteInformationComponent } from '@shared/components/complete-information/complete-information.component';
import { STORE_QUERY_PARAMS } from '@store/user/user.action';
import { SummaryPopupComponent } from 'src/app/popup/summary-popup/summary-popup.component';
import { ClauseMessageComponent } from '@shared/components/modal/clause-message/clause-message.component';
import { UploadDocumentComponent } from '@shared/components/upload-document/upload-document.component';
import { EmailDocumentComponent } from '@shared/components/modal/email-document/email-document.component';
import { AccessConfig, ButtonAccessConfig } from '@shared/helpers/sat-menu-access-config';
import { MenuAccessService } from '@shared/services/sat-menu-access/menu-access.service';

@Component({
  selector: 'app-endorsement-complete',
  standalone: true,
  imports: [
    SharedModule,
    CompleteInformationComponent
  ],
  templateUrl: './endorsement-complete.component.html',
  styleUrl: './endorsement-complete.component.scss'
})
export class EndorsementCompleteComponent implements OnInit{
  
  @Select(SatMotorState.motorStep4Summary) step4$: Observable<any>;
  @Select(SatMotorState.endorsementStep3) endtSummary$: Observable<any>;
  @Select(SatMotorState.motorActionType) actionType$;
  @Select(SatMotorState.rtpStep2Summary) rtpSummary$: Observable<any>;

  @ViewChild("tmplEndtNotExist") endtNotExist!: TemplateRef<any>;

  isIssuance: boolean = false; 
  isEndorsement: boolean = false; 
  isEnquiry: boolean = false;
  isRTP: boolean = false;

  templateDialogRef?: NxModalRef<any>;
  componentDialogRef?: NxModalRef<EndorsementCompleteComponent>;
  componentDialogRef2?: NxModalRef<SummaryPopupComponent>;
  emailDocumentModal?: NxModalRef<EmailDocumentComponent>;

  componentDialogRef1?: NxModalRef<EnquiryPopupComponent>;

  referralRemarksModal?: NxModalRef<RemarksComponent>;
  requestCancellationModal?: NxModalRef<RequestCancellationComponent>;
  remarksAddedModal?: NxModalRef<RemarksAddeddComponent>;
  clauseMsgModal?: NxModalRef<ClauseMessageComponent>;
  dialogRef?: NxModalRef<any>;

  agentInfo: any;
  userInfo: UserResponse;
  declarationInfo: any;
  customerPartnerInfo: any;
  crossSellList: any = [];
  marketingConsent: any;
  data: any;
  okMessageModal?: NxModalRef<OkMessageComponent>;
  queryParam: any;
  cnoteType: any;
  endtType: any;
  completeData: any;
  isQuotationGenerated: boolean = false;
  isEndorsementGenerated: boolean = false;
  isEndtNoExist: boolean = false;
  isDataLoaded: boolean = false;
  showTitleMessage: boolean = false;
  titleMessage: string;
  status: any;
  classType: any;
  referralReasonList: any;

  isShowCancellationBtn: boolean = false;
  isShowReferralRemarksBtn: boolean = false;
  isShowQuotationPDFBtn: boolean = false;
  isShowSchedulePDFBtn: boolean = false;
  isShowCertificatePDFBtn: boolean = false;
  isShowInvoicePDFBtn: boolean = false;
  isShowUploadBtn: boolean = false;
  isUpdatePayment: boolean = false;

  statusMap = {
    PRINTED: "Printed",
    APPROVED: "Approved",
    PENDING: "Pending Approval",
    CANCELLED: "Cancelled",
    SUBMITTED: "Submitted",
    ACTIVE: "Active",
    EXPIRED: "Expired"
  };

  classTypeMap = {
    PRINTED: "printed_badge",
    APPROVED: "approved_badge",
    PENDING: "pending_badge",
    CANCELLED: "cancel_badge",
    SUBMITTED: "submitted_badge",
    ACTIVE: "active_badge",
    EXPIRED: "expired_badge"
  };

  constructor(
    private dialogService: NxDialogService,
    private router: Router,
    private store: Store,
    private cdr: ChangeDetectorRef,
    private accessService: MenuAccessService
  ) { }

  ngOnInit() {
    this.store.dispatch(new SET_CURRENT_STEP(4));
    window.scroll({ top: 0, left: 0, behavior: 'instant' });
    this.userInfo = this.store.selectSnapshot<UserResponse>(state => state.UserState.user);
    this.queryParam = this.store.selectSnapshot<any>((state) => state.UserState.queryParams);
    this.endtType = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.issuance?.issuance?.endorsementType);
    this.isUpdatePayment = this.store.selectSnapshot<any>(state => state.SatMotorState.isUpdatePayment);
    this.populateCompleteScreen();
    this.getDocumentListLov();
  }

  getDocumentListLov() {
    this.store.dispatch(new GET_DOCUMENT_LOV({
      lob: "MT",
      userId: this.userInfo.userId,
      productCode: this.data.productCode,
      productType: "",
      type: 'SATMTCNDOCTYPE'
    }));
  }

  populateCompleteScreen() {
    this.completeData = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step4?.cngeNote) ?? null;

    if (!this.completeData) {
      this.loadEndorsementData();
    } else {
      this.processEndorsementData(this.completeData);
    }
  }

  loadEndorsementData() {
    this.endtSummary$.subscribe(summary => {
      const { generateQuotation, sendToJPJ, updatePayment } = summary || {};
      const sendToJPJData = sendToJPJ?.data?.cngeNoteDto;
      const generateQuotationData = generateQuotation?.data?.cngeNoteDto;
      const updatePaymentData = updatePayment?.data?.cngeNoteDto; 

      if (sendToJPJData) {
        this.isEndorsementGenerated = true;
        this.isEndtNoExist = !!sendToJPJData.endtNo;
        this.processEndorsementData(sendToJPJData);
      } else if (generateQuotationData) {
        this.isQuotationGenerated = true;
        this.processEndorsementData(generateQuotationData);
      } else if (this.isUpdatePayment && updatePaymentData){
        this.isQuotationGenerated = !!updatePaymentData.proposalNo;
        this.isEndorsementGenerated = !!updatePaymentData.cnoteNo;
        this.processEndorsementData(updatePaymentData);
      } 
    });
  }

  processEndorsementData(endorsementData: any) {
    const generateQuotationData = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.generateQuotation?.data?.cngeNoteDto);
    const sendToJPJData = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.sendToJPJ?.data?.cngeNoteDto);

    if ((sendToJPJData && endorsementData.contractId !== sendToJPJData.contractId)) {
      this.data = sendToJPJData;
    } else if ((generateQuotationData && endorsementData.contractId !== generateQuotationData.contractId)) {
      this.data = generateQuotationData;
    } else {
      this.data = endorsementData;
    }

    this.getTitleMessage();
    this.status = this.statusMap[this.getStatus()] || "";
    this.classType = this.classTypeMap[this.getStatus()] || "";
    //this.storeCompleteData();
    this.showCancellationButton();
    this.showRemarksButton();
    this.showQuotationPDFBtn();
    this.showSchedulePDFBtn();
    this.showCertificatePDFBtn();
    this.showInvoicePDFBtn();
    this.showUploadBtn();
    this.isDataLoaded = true;
  }

  storeCompleteData() {
    this.cdr.markForCheck();
    this.cdr.detectChanges();

    const payload = {
      isIssuance: false,
      isRTP: false,
      isEndorsement: true,
      cngeNote: this.data
    };

    this.store.dispatch(new STORE_COMPLETE_DATA(payload)).subscribe(() => {
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    });
  }

  getStatus() {
    return this.data.cnoteStatus;
  }

  getMessage() {
    if (this.isUpdatePayment) {
      return "Your Payment Details has been successfully updated.";
    }else if (this.isEndorsementGenerated) {
      switch (this.getStatus()) {
        case 'PRINTED':
          return 'Your Endorsement has been successfully generated.';
        case 'PENDING':
          return 'Your Endorsement has been submitted as pending approval.';
        case 'CANCELLED':
          return 'Your Endorsement has been cancelled.';
        default:
          return null;
      }
    } else if (this.isQuotationGenerated) {
      switch (this.getStatus()) {
        case 'PRINTED':
          return 'Your e-Quotation has been generated.';
        case 'CANCELLED':
          return 'e-Quotation has been cancelled successfully.';
        default:
          return null;
      }
    } else {
      return null;
    }
  }

  getTitleMessage() {
    this.titleMessage = this.getMessage();
    if (this.titleMessage && this.titleMessage != '') {
      this.showTitleMessage = true;
    }
  }

  isQuotationOrCoverNote() {
    //return this.isEndorsementGenerated ? 'Cover Note' : 'e-Quotation';
    return 'Endorsement';
  }

  getStatusDescription() {
    switch (this.getStatus()) {
      case 'PRINTED':
        return 'Printed';
      case 'PENDING':
        return 'Pending Approval';
      case 'CANCELLED':
        return 'Cancelled';
      default:
        return null;
    }
  }

  getProductName() {
    const productName = this.data?.productName ?? null;

    if (typeof productName !== 'string' || !productName.trim()) {
      return null;
    }

    return productName
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  getCoverNoteNumber() {
    let text = '';
    if ((this.data.proposalNo && this.data.proposalNo != '') && (this.data.cnoteNo && this.data.cnoteNo != '')) {
      text = this.data.proposalNo + ' / ' + this.data.cnoteNo;
    } else if (this.data.proposalNo && this.data.proposalNo != '') {
      text = this.data.proposalNo;
    } else if (this.data.cnoteNo && this.data.cnoteNo != '') {
      text = this.data.cnoteNo;
    }
    return text;
  }

  getQuotationMessage() {
    if (this.isEndorsementGenerated && this.getStatus() === 'PRINTED') {
      return 'has been issued. You may save a digital copy of the Endorsement by clicking on the Download Endorsement Schedule button below.';
    } else if (this.isEndorsementGenerated && this.getStatus() === 'PENDING') {
      this.setReferralCode(this.data.referList);
      return 'The Endorsement you have just submitted is a referral case based on the following reason(s):';
    } else if (this.isQuotationGenerated && this.getStatus() === 'PRINTED') {
      return 'has been successfully downloaded. You may save a digital copy of the e-Quotation by clicking on the e-Quotation PDF button below.';
    }else if(this.getStatus() === 'CANCELLED'){
      this.setReferralCode(null);
      return '';
    }else {
      return '';
    }
  }

  setReferralCode(referList: any) {
    if(referList && referList.length > 0) {
      this.referralReasonList = referList;
    } else {
      this.referralReasonList = [];
    }
  }

  showCancellationButton() {
    this.isShowCancellationBtn = (this.getStatus() === 'PENDING' || this.getStatus() === 'PRINTED') && !this.isUpdatePayment;
  }

  showRemarksButton() {
    this.isShowReferralRemarksBtn = this.isEndorsementGenerated && this.getStatus() === 'PENDING';
  }

  showQuotationPDFBtn() {
    this.isShowQuotationPDFBtn = this.isQuotationGenerated && !this.isEndorsementGenerated && this.getStatus() === 'PRINTED';
  }

  showSchedulePDFBtn() {
    this.isShowSchedulePDFBtn = this.isEndorsementGenerated && this.getStatus() === 'PRINTED';
  }

  showCertificatePDFBtn() {
    const validEndorsementTypes = ['COE', 'XP', 'ENDT04', 'ENDT12', 'ENDT34', 'ENDT23', 'ENDT24', 'ENDT25'];

    this.isShowCertificatePDFBtn = true;

    if (!this.isEndorsementGenerated) {
      console.log('Condition failed: Endorsement is not generated.');
      this.isShowCertificatePDFBtn = false;
    }

    if (this.getStatus() !== 'PRINTED') {
      console.log(`Condition failed: Status is '${this.getStatus()}', expected 'PRINTED'.`);
      this.isShowCertificatePDFBtn = false;
    }

    if (!validEndorsementTypes.includes(this.endtType)) {
      console.log(`Condition failed: endtType '${this.endtType}' is not valid.`);
      this.isShowCertificatePDFBtn = false;
    }

    console.log(`isShowCertificatePDFBtn: ${this.isShowCertificatePDFBtn}`);
  }

  showInvoicePDFBtn() {
    this.isShowInvoicePDFBtn = true;

    if (!this.data?.einvoiceConsentInd) {
      console.log('Condition failed: einvoiceConsentInd is not set or invalid.');
      this.isShowInvoicePDFBtn = false;
    }

    if (this.getStatus() !== 'PRINTED') {
      console.log(`Condition failed: Status is '${this.getStatus()}', expected 'PRINTED'.`);
      this.isShowInvoicePDFBtn = false;
    }

    if (!this.data?.premiumDue || this.data.premiumDue <= 0) {
      console.log(`Condition failed: premiumDue is '${this.data?.premiumDue}', expected a positive value.`);
      this.isShowInvoicePDFBtn = false;
    }

    console.log(`isShowInvoicePDFBtn: ${this.isShowInvoicePDFBtn}`);
  }

  showUploadBtn() {
    this.isShowUploadBtn = this.getStatus() === 'PRINTED' || this.getStatus() === 'PENDING';
  }

  openRequestCancellationPopUp() {
    let data = {
      summaryData: this.data,
      isEndorsement: true
    }

    this.requestCancellationModal = this.dialogService.open(RequestCancellationComponent, {
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      data: data
    });

    this.requestCancellationModal.afterClosed().subscribe(result => {
      if (result) {
        let payload = {
          cancelRemarks: result.data.cancelRemarks,
          cancelReasonCode: result.data.cancellationReason,
          contractId: this.data.contractId,
          operator: this.userInfo.userId
        };

        if (result.isCancelAndReplace) {
          this.store.dispatch(new CANCEL_REPLACE(payload)).subscribe((state) => {
            let cancellationRes = state.SatMotorState.data.cancellationRes;

            this.store.dispatch(new CALCULATE_ENDT_PREMIUM({ ...cancellationRes, operator: this.userInfo.userId })).subscribe(state => {
              const coveragePremium = state.SatMotorState.endorsement?.step2?.endorsementDetails?.coveragePremium?.data;
              this.store.dispatch(new COPY_CNGE_TO_ENDORSEMENT_STATE({ ...cancellationRes, cngeNoteDto: coveragePremium.cngeNoteDto })).subscribe(state => {
                this.router.navigate(['endorsement/summary']);
              });
            });
          });
        } else {
          if (this.isQuotationGenerated) {
            this.store.dispatch(new CANCEL_QUOTATION(payload)).subscribe(state => {
              let cancellationRes = state.SatMotorState.data.cancellationRes;
              if (cancellationRes) {
                this.data = cancellationRes;
                this.processEndorsementData(cancellationRes);
                this.cdr.markForCheck();
                this.cdr.detectChanges();
                this.storeCompleteData();
              }
            });
          } else {
            this.store.dispatch(new CANCEL_COVER_NOTE(payload)).subscribe(state => {
              let cancellationRes = state.SatMotorState.data.cancellationRes;
              if (cancellationRes) {
                this.data = cancellationRes;
                this.processEndorsementData(cancellationRes);
                this.cdr.markForCheck();
                this.cdr.detectChanges();
                this.storeCompleteData();
              }
            });
          }
        }
      }
    });
  }

  openPopupReferralRemarks() {
    this.referralRemarksModal = this.dialogService.open(RemarksComponent, {
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      data: {
        title: "Please add remarks",
        primaryButtonLabel: "SUBMIT"
      }
    });

    this.referralRemarksModal.afterClosed().subscribe(result => {
      if(result) {
        const data = {
          remark: result.remarks,
          operator: this.userInfo.userId,
          contractId: this.data.contractId,
          isEndorsement: true
        };
        this.store.dispatch(new SAVE_REFERRAL_REMARKS(data)).subscribe(state => {
          this.remarksAddedModal = this.dialogService.open(RemarksAddeddComponent, {
            showCloseIcon: false,
            disableClose: true,
            width: '550px',
            maxWidth: '550px'
          });
        });
      }
    });
  }

  uploadDocument() {
    let dialogConfig = {
      showCloseIcon: false,
      disableClose: true,
      width: "80%",
      maxWidth: "80vw",
      maxHeight: "95vh",
      data: {
        contractId: this.data.contractId
      }
    };

    this.dialogRef = this.dialogService.open(UploadDocumentComponent, dialogConfig);
  }

  downloadPDF(contractId, type) {
    let payload = {
      operator: this.userInfo.userId,
      contractId: contractId ? contractId : this.data.contractId,
      type: type
    };

    this.store.dispatch(new DOWNLOAD_PDF(payload));
  }

  retrieveLatestEndtNo(type) {
    this.store.dispatch(new GET_QUOTATION_DETAIL_ENDT(this.data.contractId, "SUMMARY")).subscribe((state) => {
      let cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.viewQuotation);

      if (cngeNote) {
        console.log("Current Endt No: " + (cngeNote.endtNo ? cngeNote.endtNo : 'null'));
        this.isEndtNoExist = !!cngeNote.endtNo;

        if (type == 'cancel') {
          if (this.isEndtNoExist) {
            this.data = cngeNote;
            this.showOkMessage('Endorsement generated, cannot cancel.');
          } else if (!this.isEndtNoExist && cngeNote.jpjStatus === 'SENT') {
            this.data = cngeNote;
            this.showOkMessage('JPJ Status Sent, please try again.');
          } else {
            this.data = cngeNote;
            this.openRequestCancellationPopUp();
          }
        
        } else if (type == 'email') {
          if (this.isEndtNoExist) {
            this.data = cngeNote;
            this.emailDocument();
          } else {
            this.dialogService.open(this.endtNotExist, {
              ariaLabel: "A simple dialog",
              showCloseIcon: false,
              disableClose: true,
              width: '95%',
              maxWidth: '400px',
            });
          }
        }
      }
    });
  }

  checkLatestEndtNo(contractId, type, showClausePopup) {
    this.store.dispatch(new GET_QUOTATION_DETAIL_ENDT(this.data.contractId, "SUMMARY")).subscribe((state) => {
      let cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.viewQuotation);
      
      if (cngeNote) {
        console.log("Current Endt No: " + (cngeNote.endtNo ? cngeNote.endtNo : 'null'));
        this.isEndtNoExist = !!cngeNote.endtNo;
        
        if (this.isEndtNoExist) {
          if (cngeNote.cnoteType === 'XP' || type === 'endorsementCI') {
            showClausePopup = false;
          }
          this.data = cngeNote;
          this.checkDownloadPDF(contractId, type, showClausePopup);
        } else {
          this.dialogService.open(this.endtNotExist, {
            ariaLabel: "A simple dialog",
            showCloseIcon: false,
            disableClose: true,
            width: '95%',
            maxWidth: '400px',
          });
        }
        
      }
    });
  }

  checkDownloadPDF(contractId, type, showClausePopup) {
    // if (!this.isEndtNoExist) {
    //   this.showOkMessage('Endorsement not generated yet, please try again.');
    
    // } else {
      if (showClausePopup) {
        const payload: any = {
          operator: this.userInfo.userId,
          contractId: contractId ? contractId : this.data.contractId,
          type: type,
        };
  
        if (this.data.cnoteType === 'ENDT17' || this.data.cnoteType === 'ENDT18') {
          this.clauseMsgModal = this.dialogService.open(ClauseMessageComponent, {
            disableClose: true,
            width: '450px',
            maxWidth: '450px',
          });
          this.clauseMsgModal.afterClosed().subscribe(result => {
            payload.printClauseInd = (result === 'Y');
            this.store.dispatch(new DOWNLOAD_PDF(payload));
          });
        } else {
          this.downloadPDF(contractId, type);
        }
      
      } else {
        this.downloadPDF(contractId, type);
      }
    //}
  }

  showOkMessage(message) {
    this.okMessageModal = this.dialogService.open(OkMessageComponent, {
      disableClose: true,
      width: '400px',
      data: {
        message: message
      }
    });
  }

  backToSummaryListing() {
    this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe((state) => {
      let switchSiteUrl = state.SatMotorState.data.switchSiteUrl;
      console.log("SwitchSiteUrl Url : " + switchSiteUrl);
      window.location.href = switchSiteUrl;
    });
  }

  goToViewPage() {
    this.queryParam = {
      ...this.queryParam,
      contractId: this.data.contractId,
      action: 'COMPLETE'
    }
    this.store.dispatch(new STORE_QUERY_PARAMS(this.queryParam)).subscribe(() => {
      this.router.navigate(["/view-endorsement"]);
    });
  }

  onContinueIssuance() {
    let cngeNote = JSON.parse(JSON.stringify(this.data));
    this.store.dispatch(new RESET_MOTOR_STATE()).subscribe((state) => {
      this.store.dispatch(new SET_ACTION('ISSUE'));
      this.store.dispatch(new GET_AGENT_LIST_AGENT({ userId: this.userInfo.userId })).subscribe(() => {
        this.actionReroute(cngeNote);
      });
    });
  }

  async actionReroute(cngeNote) {
    const payload = {
      operator: this.userInfo.userId,
      agentCode: cngeNote.mkagAgent.agentCode,
      productType: "MT",
    };
    let agentDetailRes = await this.store.dispatch(new GET_AGENT_DETAIL_ONLY(payload)).toPromise();
    if (agentDetailRes) {
      this.store.dispatch(new GET_PRODUCT_LIST({ lob: 'MT', agentCode: cngeNote.mkagAgent.agentCode })).subscribe(() => {
        this.router.navigate(['issuance/declaration-issuance-info']);
      });

    }
  }

  emailDocument() {
    this.emailDocumentModal = this.dialogService.open(EmailDocumentComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: "95%",
      maxWidth: "900px",
      maxHeight: "95vh",
      data: { popup_type: 'emaildocument' },
    });
  }

  isDisableInvoiceButton() {
    return (this.data?.einvoiceStatus && this.data?.einvoiceStatus === 'VALID') ? 
    this.validateAccess(AccessConfig.TAX_INVOICE) : true;
  }

  isDisableRequestCancel(): boolean {
    return this.validateAccess(AccessConfig.CANCEL_ENDORSEMENT);
  }

  isDisableSchedulePDF(): boolean {
    return this.validateAccess(AccessConfig.ENDORSEMENT_PDF_SCHEDULE);
  }

  isDisableQuotationPDF(): boolean {
    return this.validateAccess(AccessConfig.ENDORSEMENT_PDF);
  }

  isDisableCertificatePDF(): boolean {
    return this.validateAccess(AccessConfig.ENDORSEMENT_PDF_CERTIFICATE);
  }

  isDisableViewEndorsement(): boolean {
    return this.validateAccess(AccessConfig.VIEW_ENDORSEMENT);
  }

  validateAccess(config: ButtonAccessConfig): boolean {
    return this.accessService.checkAccess(config);
  }

}
